import React, { Component, ErrorInfo, ReactNode } from 'react';
import { logger } from '@/lib/logger';

interface MilestoneErrorBoundaryProps {
  children: ReactNode;
  itemId?: string;
  milestoneName?: string;
}

interface State {
  hasError: boolean;
}

/**
 * Error boundary for milestone components
 * Prevents individual milestone rendering errors from crashing the entire timeline
 */
export class MilestoneErrorBoundary extends Component<MilestoneErrorBoundaryProps, State> {
  public state: State = {
    hasError: false
  };

  public static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    logger.error('MilestoneErrorBoundary', 'Milestone rendering error', {
      itemId: this.props.itemId,
      milestoneName: this.props.milestoneName,
      error: error.message,
      stack: error.stack,
      componentStack: errorInfo.componentStack
    });
  }

  public render() {
    if (this.state.hasError) {
      // Silent fail - don't render anything, just skip this milestone
      return null;
    }

    return this.props.children;
  }
}
